import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Modal, Spinner, Stack } from 'react-bootstrap';
import LineOfCredit from './LineOfCredit';
import TermLoan from './TermLoan';
import { ModalType } from 'states/initialState';
import { useTracking } from 'react-tracking';

const ConfirmationModal = ({
  sendingConfirmation,
  selectedDeal,
  businessId,
  deal,
  loc,
  email,
  show,
  handleClose,
  handleConfirmation,
  modalType
}) => {
  const { trackEvent } = useTracking();

  const handleClick = () => {
    if (modalType === ModalType.LOC) {
      let locDeal = selectedDeal;
      locDeal.offerId = loc.offerId;
      locDeal.loanSpecifics = [
        {
          centsOnDollar: Math.round(loc.centsOnDollar * 1000) / 1000,
          collectionType: loc.collectionType,
          line: loc.lineAmount,
          paymentFrequency: loc.paymentFrequency[0],
          productType: ModalType.LOC,
          requestedCommission: 0,
          term: loc.term
        }
      ];
      handleConfirmation(locDeal, deal, loc);
    } else {
      selectedDeal.centsOnDollar =
        Math.round(selectedDeal.centsOnDollar * 1000) / 1000;
      selectedDeal.buyRate = Math.round(selectedDeal.buyRate * 1000) / 1000;
      selectedDeal.sellRate = Math.round(selectedDeal.sellRate * 1000) / 1000;
      handleConfirmation(selectedDeal, deal, loc);
    }
    trackEvent({
      event: 'Price for Checkout',
      opportunityId: businessId
    });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title>
          <FormattedMessage id="confirmation.title" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {modalType === ModalType.LOC ? (
          <LineOfCredit deal={loc} email={email} />
        ) : (
          <TermLoan deal={deal} email={email} />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="link"
          onClick={() => {
            handleClose();
            trackEvent({
              event: 'Edit Offer',
              opportunityId: businessId
            });
          }}
          className="text-decoration-none px-3 fw-600"
        >
          <FormattedMessage id="confirmation.editOffer" />
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            handleClick();
          }}
          data-testid="buttonConfirmation"
          style={{ width: '185px' }}
        >
          {sendingConfirmation ? (
            <Stack gap={2} direction="horizontal" className="ms-4">
              <Spinner animation="border" variant="light" size="sm" />
              <FormattedMessage id="confirmation.sending" />
            </Stack>
          ) : (
            <FormattedMessage id="confirmation.send" />
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
